const SEMICOLON_DELIMITER = ';'
const COMMA_DELIMITER = ','

const PSK_TEMPLATE = {
  url: '/docs/rooms_metk.csv',
  columns: ['name', 'vlan', 'passphrase', 'description'],
  requiredColumnsCount: 2
}
const DEFAULT_TEMPLATE = {
  url: '/docs/rooms.csv',
  columns: ['name', 'description'],
  requiredColumnsCount: 1
}

export const getTemplate = withPsk => (withPsk ? PSK_TEMPLATE : DEFAULT_TEMPLATE)

export const getColumnsRange = withPsk => {
  const { columns, requiredColumnsCount } = getTemplate(withPsk)
  return { min: requiredColumnsCount, max: columns.length }
}

const hasValidColumnsCount = (cells, withPsk) => {
  const { min, max } = getColumnsRange(withPsk)
  return cells.length >= min && cells.length <= max
}

const detectDelimiter = lines => {
  const headerLine = lines.find(line => line.trim()) ?? ''
  return headerLine.includes(SEMICOLON_DELIMITER) ? SEMICOLON_DELIMITER : COMMA_DELIMITER
}

const parseCsvLines = data => {
  const lines = data.split(/\r?\n/)
  const delimiter = detectDelimiter(lines)
  return lines
    .map((line, index) => ({ lineNumber: index + 1, line }))
    .filter(({ line }) => line.trim())
    .map(({ lineNumber, line }) => ({ lineNumber, cells: line.split(delimiter) }))
}

export const getInvalidLineNumbers = (data, withPsk) =>
  parseCsvLines(data)
    .filter(({ cells }) => !hasValidColumnsCount(cells, withPsk))
    .map(({ lineNumber }) => lineNumber)

export const parseCsv = (data, withPsk) =>
  parseCsvLines(data)
    .slice(1)
    .map(({ cells }, index) => {
      if (withPsk) {
        const [name, vlan, passphrase, description] = cells
        return { id: String(index), name, vlan, passphrase, description }
      }
      const [name, description] = cells
      return { id: String(index), name, description }
    })

const toImportRow = ({ name, vlan, passphrase, description }, withPsk) => {
  const row = { name: name.trim(), description: description?.trim() ?? '' }
  if (!withPsk) {
    return row
  }
  const trimmedPassphrase = passphrase?.trim()
  return {
    ...row,
    psk: { vlan: Number(vlan), ...(trimmedPassphrase && { passphrase: trimmedPassphrase }) }
  }
}

export const buildImportRows = (data, withPsk) => parseCsv(data, withPsk).map(space => toImportRow(space, withPsk))
